import PropTypes from 'prop-types';
import React from 'react';
import T from 'components/T';
import { i18n } from '@international/mastodon-i18n';
import { AssessStatuses } from '@dashboard-experience/utils';
import { getScreeningStatusAndAssessment } from '../utils';

import Panel from '../../../Panels';
import Search from '../Search/Search';

class NationalCriminalSearch extends React.Component {
  render() {
    const { search } = this.props;

    if (!search) {
      return null;
    }

    if (search.status === 'canceled') {
      return null;
    }
    const useScreeningStatusOverAssessment =
      search?.assessment?.display?.decision === AssessStatuses.ELIGIBLE;

    if (search.records.length) {
      return (
        <Search
          dataTestId='national-criminal-search'
          type='criminal'
          title={i18n.getStr('components.nationalCriminalSearch.title')}
          search={search}
          assessmentEnabled
          useScreeningStatusOverAssessment={useScreeningStatusOverAssessment}
        />
      );
    }

    const { searchStatus, statusType, secondaryStatus } =
      getScreeningStatusAndAssessment(
        true,
        useScreeningStatusOverAssessment,
        search,
      );

    return (
      <Panel
        data-testid='national-criminal-search'
        title={i18n.getStr('components.nationalCriminalSearch.title')}
        status={searchStatus}
        statusType={statusType}
        secondaryStatus={secondaryStatus}
      >
        {search.status === 'consider' && (
          <span>
            <T value='components.nationalCriminalSearch.seeCountySearch' />
          </span>
        )}
      </Panel>
    );
  }
}

NationalCriminalSearch.propTypes = {
  search: PropTypes.object,
};

NationalCriminalSearch.defaultProps = {
  search: null,
};

export default i18n.renderTranslation()(NationalCriminalSearch);
